import { gql } from "@apollo/client"
  
const GET_CLIENT_SETTINGS = gql`  
  query clientSettings($clientId: ID!) {
    client(id: $clientId) {
      id
      
      settings {
        id
        client_id
        phone
        email
        unbook_on_non_attendance
        logo_background_color
        allow_teacher_availability
        allow_teacher_bookings
        allow_teacher_reports
        require_legal_guardian
        is_sb_account_sso
      }
    
      assets {
        id
        filename
        type {
          id
          type
          code
          rules
        }
      }
    }
  }
`

export { GET_CLIENT_SETTINGS }